import styled from 'styled-components';

const Divider = styled.div`
  width: 100%;
  margin: 30px 0;

  border-top: 2px solid ${({ theme }) => theme.colors.blackHaze};

  ${({ theme }) => theme.devices.tablet`
    margin: 35px 0;
  `}
`;

export default Divider;
